import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { adminService } from "@/api/services/adminService"; // Adjust the path as needed


// Define TypeScript interface
interface FunctionalItem {
  id: string;
  functionalName: string;
}

interface FunctionalState {
  data: FunctionalItem[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: FunctionalState = {
  data: [],
  loading: false,
  error: null,
};

// Async thunk for fetching data
export const fetchFunctionalData = createAsyncThunk(
    "functional/fetchAll",
    async (_, { rejectWithValue }) => {
      try {
        const response = await adminService.functionalAll();
        console.log("API Response:", response);
        return response.data?.map((item: any) => ({
          id: item.id,
          functionalName: item.functionalName,
        }));
      } catch (error) {
        return rejectWithValue("Failed to fetch Functional data");
      }
    }
  );
  

const functionalSlice = createSlice({
  name: "functional",
  initialState,
  reducers: {
    resetFunctionalState: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFunctionalData.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchFunctionalData.fulfilled,
        (state, action: PayloadAction<FunctionalItem[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchFunctionalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetFunctionalState } = functionalSlice.actions;

export default functionalSlice.reducer;
